import { get } from 'axios';

const { VUE_APP_API_URL } = process.env || {};

export const getPoDepartmentNumbers = (token) => get(`${VUE_APP_API_URL}/api/v1/admin/poDepartmentNumbers`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
